export const EXIT_BUTTON = 'EXIT_BUTTON';
